import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnInit, inject } from '@angular/core'
import { MatTooltip } from '@angular/material/tooltip'
import { Deal } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed'
import { Observable } from 'rxjs'

@Component({
  selector: 'tc-forex-warning',
  template: `<span class="fa fa-history"></span>`,
  styles: [`:host:not(.visible) { display: none }`],
  providers: [MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ForexWarningComponent extends OnDestroyMixin implements OnInit {
  private readonly tooltip = inject(MatTooltip)

  constructor() {
    super();
    this.tooltip.message = "This deal uses outdated FX rates (over 1 hour old).";
    this.tooltip.tooltipClass = 'pre-tooltip';
  }

  
  @Input() deal: Observable<DeepReadonly<Deal>>

  @HostBinding('class.visible') outdatedRates: boolean;

  @HostListener('mouseenter') onMouseEnter(): void {
    this.tooltip.show();
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    this.tooltip.hide();
  }

  ngOnInit() {
    this.deal.pipe(untilComponentDestroyed(this)).subscribe((deal) => {
      this.outdatedRates = deal?.attributes?.fx_rates?.outdated;
    })
  }
}
